import { AuditSchedule } from '@mi-front/core';
import { AsyncChildProps, AsyncView } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../../api';
import { SchedulesViewViewP } from './view_p';
import { Station } from '@app/core/types/stations';

interface Props {
  readonly station: Station;
  readonly scheduleId: string;
}

export function SchedulesViewView(p: Props) {
  const { $t } = useIntl();

  return (
    <AsyncView
      promiseFn={({ query }) => apiClient.audit.fetchSchedule(p.station.slug, p.scheduleId)}
      query={{}}
      silent
      loader={$t({
        id: 'audit.schedulesViewScreen.loading',
        defaultMessage: 'Cargando schedule',
      })}
    >
      {(vp: AsyncChildProps<AuditSchedule>) => (
        <SchedulesViewViewP
          data={{
            station: p.station,
            schedule: vp.data,
          }}
        />
      )}
    </AsyncView>
  );
}
